<template>
    <el-form
            ref="formRef"
            style="max-width: 600px"
            :model="dataForm"
            :rules="rules"
            :disabled="loading"
            label-width="auto"
            v-loading="loading"
    >

        <el-form-item
            :label="i18n.tkey('lang_unit_name_zh')"
            prop="description"
        >
            <el-input
                    v-model="dataForm.description"
                    type="text"
                    autocomplete="off"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_unit_name_en')"
            prop="description2"
        >
            <el-input
                    v-model="dataForm.description2"
                    type="text"
                    autocomplete="off"
            />
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="submitForm(formRef)" v-if="null == editObj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
            <el-button type="primary" @click="submitForm(formRef)" v-if="null != editObj" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
<!--            <el-button @click="resetForm(formRef)">Reset</el-button>-->
        </el-form-item>
    </el-form>
</template>

<script setup>
    import {inject, reactive, ref, toRef, onBeforeMount} from 'vue'
    import eshopopeeApi from "@/request/eshopopeeApi";
    import {useCompanyinfo} from "@/stores/companyinfo";
    import myUtil from "@/util/util";

    const props = defineProps(["editObj"])
    const emits = defineEmits(["save-complete"])

    const i18n = inject("i18n")

    //響應機制的companyinfo
    const companyInfoRef = toRef(useCompanyinfo())

    const loading = ref(false)

    const formRef = ref(null)

    const shopCompany = ref({})
    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return companyInfoRef.value } })

    const rules = reactive({
        description: [
            { required: true, message: i18n.tkey("lang_pls_input_unit_zh_name") },
        ],
        description2: [
            { required: true, message: i18n.tkey("lang_pls_input_unit_en_name") },
        ],
    })

    const dataForm = reactive({
        description: '',
        description2: '',
    })

    const submitForm = (formEl) => {
        if (!formEl) return
        formEl.validate((valid) => {
            if (valid) {
                if (null == props.editObj){
                    submitData()
                }else{
                    updateData()
                }

            }
        })
    }

    // const resetForm = (formEl) => {
    //     if (!formEl) return
    //     formEl.resetFields()
    // }

    function submitData() {
        loading.value = true

        const request = eshopopeeApi.insertUnit
        const params = request.getParams()

        params.CompanyCode = shopCompany.value.acccompanycode
        params.description = dataForm.description
        params.description2 = dataForm.description2
        params.unitCode = params.description

        request.send(params, (res) => {
            if (res.code == 200){
                loading.value = false
                formRef.value.resetFields()
                myUtil.alertSuccess(i18n.tkey("lang_submit_success"))
                emits("save-complete")
            }else if(res.code == 500){
                myUtil.alertWarning(i18n.tkey("lang_unit_repeat_warning"))
            }else{
                myUtil.alertError(i18n.tkey("lang_request_error"))
            }
        })

    }

    function updateData(){
        const request = eshopopeeApi.updateUnit
        const params = request.getParams()

        params.id = props.editObj.id
        params.CompanyCode = props.editObj.CompanyCode
        params.unitCode = props.editObj.unitCode
        params.description = dataForm.description
        params.description2 = dataForm.description2

        request.send(params, (res) => {
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                emits("save-complete")
            }else{
                myUtil.alertError(i18n.tkey("lang_request_error"))
            }
        })

    }

    onBeforeMount(() => {
        shopCompany.value = getShopCompanyObj()

        if (null != props.editObj){
            dataForm.description = props.editObj.description
            dataForm.description2 = props.editObj.description2
        }
    })

</script>

<style scoped>

</style>